module.exports = __webpack_public_path__ + "img/noData.f40351ca.png";